import * as dc from "@/components/layout/list/defaultType";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { getSelectPageUserAuth } from "@/util/authutil";
import { enLocale } from "@/i18n/routing";
export const CafeSupplier = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;
  const select_user_auth = getSelectPageUserAuth(params, "cafe")?.user_auth;
  Debug(select_user_auth);

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_user","system_table_pk":["roaster_seq","roaster_user_seq"],"system_table_page":"RoasterUser","system_table_path":"roaster/user/list","system_table_page_name":"RoasterUser","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roasteruser","system_table_detail_result":"detail_result","system_table_search_column":["roaster_user_auth","roaster_user_use"],"system_table_search_select":["roaster_user_name","roaster_user_nick"],"system_table_order_column":["roaster_user_auth","roaster_user_nick","roaster_user_name","rgst_at"],"system_table_default_name_column":"roaster_user_name","system_table_use_column":"roaster_user_use"}
    //--info--}
    case "CafeRoaster":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/cafe/roaster/list/detail/", saveFetch: { fetchUrl: "/api/cafe/roaster/list/edit" } },
        listFetch: { fetchUrl: "/api/cafe/roaster/list/list" },
        dataResultName: "detail_result",
        dataName: "CafeRoasterData",
        editCheck: true,
        editReload: true,
        writeButton: false,
        dataCols: {
          // roaster_seq: { ...dc.seq, required: true },
          // cafe_roaster_seq: { ...dc.seq, required: true },
          // cafe_roaster_uuid: { ...dc.input },
          cafe_roaster_name_locale: { ...dc.input, maxLength: 100, edit: { disabled: true }, showCount: true },
          cafe_roaster_name: { ...dc.input, maxLength: 100, edit: { disabled: true }, showCount: true },
          cafe_roaster_nick_locale: { ...dc.input, maxLength: 100, showCount: true },
          cafe_roaster_nick: { ...dc.input, maxLength: 100, showCount: true },
          // cafe_roaster_level: { ...dc.number },
          // cafe_roaster_auth: {
          //   ...dc.select,
          //   codeGroup: "PSAUTH",
          //   maxLength: 300,
          //   showCount: true,
          //   update: {
          //     // selectFilter: {
          //     //   code_id: select_user_auth === "OWN" ? ["CSTMR", "CAFE", "RSTR", "EXCLD"] : ["CSTMR", "CAFE", "EXCLD"],
          //     // },
          //     disabled: true,
          //   },
          // },
          cafe_roaster_desc: { ...dc.textAreaM },
          // cafe_roaster_use: { ...dc.useDefault, disabled: true, read: { display: false } },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        listColLinkField: "cafe_roaster_uuid",
        base64Field: ["cafe_roaster_uuid"],
        // listSearch: [
        //   { ...dc.select, field: "search0", codeGroup: "PSAUTH", label: "cafe_roaster_auth", placeholder: "cafe_roaster_auth" },
        //   {
        //     ...dc.listSearchUse,
        //     field: "search1",
        //     label: "cafe_roaster_use",
        //     placeholder: "cafe_roaster_use",
        //   },
        // ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "cafe_roaster_nick", placeholder: "cafe_roaster_nick" },
          // { ...dc.input, field: "search_type1", label: "cafe_roaster_nick", placeholder: "cafe_roaster_nick" },
        ],
        listOrder: [
          // "cafe_roaster_auth_orderdesc",
          // "cafe_roaster_auth_orderasc",
          "cafe_roaster_nick_orderdesc",
          "cafe_roaster_nick_orderasc",
          "rgst_at_orderdesc",
          "rgst_at_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "cafe_roaster_seq",
          //"cafe_roaster_uuid",
          params?.locale === enLocale ? "cafe_roaster_nick" : "cafe_roaster_nick_locale",
          //"cafe_roaster_level",
          // { field: "cafe_roaster_auth", codeGroup: "PSAUTH" },
          // {
          //   field: "cafe_roaster_use",
          //   ...dc.liseUse,
          // },
          { field: "rgst_at", ...dc.datetime, dateFormatter: "YYYY-MM-DD" },
        ],
      };

    case "CafeRoasterRegister":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/roaster/event/cafe/register/detail",
          saveFetch: { fetchUrl: "/api/roaster/event/cafe/register/edit" },
        },
        dataResultName: "detail_result",
        dataName: "RoasterInfo",
        useDefaultId: false,
        defaultMode: "edit",
        editCheck: true,
        useList: false,
        dataCols: {
          roaster_name_locale: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            readOnly: true,
            disabled: true,
            saveData: false,
            variant: "borderless",
          },
          roaster_name: {
            ...dc.inputFull,
            labelClassName: dc.strongLabelClassName,
            readOnly: true,
            disabled: true,
            saveData: false,
            variant: "borderless",
          },
          signup_range: {
            label: "register_range_label",
            labelClassName: dc.strongLabelClassName,
            inputType: "datetimeRange",
            fieldIds: ["event_start", "event_end"],
            readOnly: true,
            disabled: true,
            saveData: false,
            variant: "borderless",
          },
          save_check: { ...dc.use, label: "register_check_label", inputClassName: "ml-2", labelClassName: dc.strongLabelClassName },
          roaster_cafe_nick_locale: {
            ...dc.inputFull,
            label: "nick_locale_label",
            minLength: 3,
            maxLength: 100,
            showCount: true,
            changePass: true,
            required: params?.locale !== enLocale ? true : undefined,
            itemClassName: params?.locale === enLocale ? "hidden" : undefined,
          },
          roaster_cafe_nick: {
            ...dc.inputFull,
            label: "nick_label",
            minLength: 3,
            maxLength: 100,
            showCount: true,
            changePass: true,
            required: params?.locale === enLocale ? true : undefined,
          },
          roaster_cafe_desc: { ...dc.textAreaDefault, maxLength: 3000, showCount: true },
        },
        listColLinkField: ["event_uuid"],
        base64Field: ["event_uuid"],
        dataReloadButton: false,
        saveDetail: "register_detail",
        saveOkDesc: "register_ok",
        saveCheck: (save_cols, obj) => {
          // Debug(save_cols, obj);
          const check_value = obj["save_check"];
          if (!check_value) {
            return { field: "save_check", message: "register_check_ok", value: 0, label: "register_check_label" };
          } else {
            return undefined;
          }
        },
        saveButtonTitle: "register_label",
        saveButtonIcon: { iconName: "Storefront", iconType: "" },
        // undoButton: false,
        cancelButton: false,
        removeButton: false,
      };
    default:
      return undefined;
  }
};
